<template>
    <div>
        <div class="input-button-group">
            <el-input placeholder="请输入教师姓名" style="width: 200px;" v-model="id"></el-input>
            <el-button @click="handleSearch" class="add-button" type="primary">搜索</el-button>
             <el-button @click="deletedata" class="add-button" type="primary">批量删除</el-button>
            <el-button type="primary" class="add-button" @click="TeacherFormDiaog(true)">添加</el-button>
            <el-upload
                class="upload-demo"
                action="#"
                :auto-upload="false"
                :on-change="handleFileChange"
                :show-file-list="false"
            >
      <!-- <el-button class="add-button" type="primary">导入数据</el-button> -->
    </el-upload>
        </div>

    </div>
</template>

<script>
import { addTeachers } from '@/api/OmdTeachers/teachers';
import XLSX from 'xlsx';
import store from '@/store';
export default {
    data() {
        return {
            id: '',
        };
    },
    methods: {
         deletedata(){
        this.$confirm('确定删除选中的教师吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.state.delete=true;
        }).catch(() => {
           
        })},
        async handleFileChange(file) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    // 获取第一个工作表
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    // 将工作表数据转换为 JSON 格式
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);
                    // 遍历 JSON 数据并添加教师信息
                    for (const teacher of jsonData) {
                        await addTeachers(teacher);
                    }
                    this.$message.success('数据导入成功');
                    this.setData(); // 刷新教师表格数据
                } catch (error) {
                    console.error('数据导入失败:', error);
                    this.$message.error('数据导入失败');
                }
            };
            reader.readAsArrayBuffer(file.raw);
        },
        handleSearch() {
          if (this.id == '' || this.id==null) {
            store.commit('setname', 'ALL');
            return; 
          }
          store.commit('setname', this.id);
            // 触发搜索操作
          this.$emit('search', this.id);
        },
        addTeacher() {
            this.dialogFormVisible = true;

        },
        TeacherFormDiaog(visible) {
            store.commit('setTeacherFormDiaog', visible); 
        },
    }
};
</script>

<style scoped>
.input-button-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}


.add-button {
    background-color: #ff69b4;
    /* 玫红色按钮背景 */
    color: white;
    border: none;
    margin-left: 10px;
    border-radius: 4px;
}

.add-button:hover {
    background-color: #ff1493;
    /* 深玫红色按钮悬停背景 */
}
</style>